import { render } from "./LottoBuyListView.vue?vue&type=template&id=f1654c32&ts=true"
import script from "./LottoBuyListView.vue?vue&type=script&lang=ts"
export * from "./LottoBuyListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__